import { GWPOld_Modal as Modal } from './GWP.old.Modal';
import { GWPOld_ProductSelector as ProductSelector } from './GWP.old.ProductSelector';
import { GWPOld_SelectedItem as SelectedItem } from './GWP.old.SelectedItem';
import { GWPOld_CalloutButton as CalloutButton } from './GWP.old.CalloutButton';

export const GWPOldDesign = {
  Modal,
  ProductSelector,
  SelectedItem,
  CalloutButton,
};
